import { Result, failure, success } from '../shared'
import { AuthProvider } from './auth.provider'
import {
  AuthServiceErrorCode,
  LoginErrorCode,
  LoginFailure,
  LoginResult,
  PasswordChangeErrorCodes,
  PasswordResetFailure,
  UserPasswordChange,
  UserVerifyFailure,
  UserVerifyResult,
} from './auth.types'

export const LOGIN_UNKNOWN_ERROR_CODE_MESSAGE = 'HINT_ERR_TITLE'

export class AuthService {
  constructor(private authProvider: AuthProvider) {}

  parseData = (error) => {
    const resStr = error.response.data
    let structureData = resStr.substring(resStr.indexOf('<body'), resStr.indexOf('</body>') + 7)
    structureData = structureData.substring(structureData.indexOf('<body>') + 6)
    structureData = structureData.substring(0, structureData.indexOf('</body>'))
    console.log(structureData)
    const body = document.querySelector('body')
    body.style.background = '#fff'
    body.innerHTML = structureData
  }

  passwordChangeErrorHandler = (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.statusText === 'Forbidden' &&
      error.response.data.indexOf('<table') >= 0
    ) {
      this.parseData(error)
    } else {
      const errorCode = error.Text
      if (PasswordChangeErrorCodes.hasOwnProperty(errorCode)) {
        return failure(PasswordChangeErrorCodes[errorCode], { message: errorCode })
      }
      return failure(LoginErrorCode.UNKNOWN, { message: LOGIN_UNKNOWN_ERROR_CODE_MESSAGE })
    }
  }

  public async login(
    username: string,
    password: string,
    otp?: string,
    otpHash?: string,
  ): Promise<Result<LoginResult, LoginFailure>> {
    try {
      const { data } = await this.authProvider.login(username, password, otp, otpHash)
      return success(data)
    } catch (error) {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.statusText === 'Forbidden' &&
        error.response.data.indexOf('<table') >= 0
      ) {
        this.parseData(error)
      } else {
        const errorCode = error.Text

        if (errorCode === 'ERR_USER_PASSWORD_EXPIRED_CHANGE') {
          return failure(LoginErrorCode[errorCode], {
            message: errorCode,
            passwordRules: error.data,
          })
        }

        if (LoginErrorCode.hasOwnProperty(errorCode)) {
          return failure(LoginErrorCode[errorCode], { message: errorCode })
        }

        return failure(LoginErrorCode.UNKNOWN, { message: LOGIN_UNKNOWN_ERROR_CODE_MESSAGE })
      }
    }
  }

  public async logout(): Promise<Result<undefined>> {
    try {
      await this.authProvider.logout()
      return success()
    } catch (error) {
      return failure(AuthServiceErrorCode.GENERAL)
    }
  }

  public async changePasswordForced(
    username: string,
    password: string,
    newPassword: string,
    otp: string,
  ): Promise<Result<undefined, LoginFailure>> {
    try {
      await this.authProvider.changePasswordForced(username, password, newPassword, otp)
      return success()
    } catch (error) {
      const errorCode = error.Text

      if (LoginErrorCode.hasOwnProperty(errorCode)) {
        return failure(LoginErrorCode[errorCode], { message: errorCode })
      }

      return failure(LoginErrorCode.UNKNOWN, { message: LOGIN_UNKNOWN_ERROR_CODE_MESSAGE })
    }
  }

  public async verifyPasswordChangeOTP(
    username: string,
    mobile: string,
  ): Promise<Result<UserVerifyResult, UserVerifyFailure>> {
    try {
      const result = await this.authProvider.verifyPasswordChangeOTP(username, mobile)
      return success(result.data)
    } catch (error) {
      const errorRes = this.passwordChangeErrorHandler(error)
      if (errorRes) return errorRes
    }
  }

  public async resetPassword(
    username: string,
    cellphone: string,
    newpass: string,
    code: string,
  ): Promise<Result<UserPasswordChange, PasswordResetFailure>> {
    try {
      const result = await this.authProvider.resetPassword(username, cellphone, newpass, code)
      return success(result.data)
    } catch (error) {
      const errorRes = this.passwordChangeErrorHandler(error)
      if (errorRes) return errorRes
    }
  }
}
